import CheckboxImage from './CheckboxImage'

export default CheckboxImage
